import { Search, SortByAlpha } from '@mui/icons-material';
import { Checkbox, Grid, ListItem, ListItemAvatar, ListItemButton, ListItemText, Paper, TextField, Tooltip } from '@mui/material';
import { Box } from '@mui/system';
import React, { useMemo, useState } from 'react';
import { filterAndSort } from '../utils';

export type AvailableFieldsProps = {
    selectedAll: boolean;
    onChangeSelectAll: () => void;
    fieldList: Record<'id' | 'name', string>[];
    selectedFieldList: Record<'id' | 'name', string>[];
    onSelectField: (field: Record<'id' | 'name', string>) => (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const AvailableFields = ({ selectedAll, onChangeSelectAll, fieldList, selectedFieldList, onSelectField }: AvailableFieldsProps) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [sortBy, setSortBy] = useState<'asc' | 'desc' | 'none'>('none');

    const filteredAndsortedFields = useMemo(() => filterAndSort(fieldList, searchQuery, sortBy), [fieldList, sortBy, searchQuery]);

    return (
        <Grid item xs={6}>
            <Paper>
                <Box>
                    <ListItem>
                        <ListItemAvatar style={{ width: '20%' }}>
                            <Checkbox checked={selectedAll} onChange={onChangeSelectAll} />
                        </ListItemAvatar>
                        <ListItemText style={{ width: '80%' }}>
                            <TextField
                                size="small"
                                margin="dense"
                                variant="outlined"
                                name="searchQuery"
                                type="search"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                InputProps={{ startAdornment: <Search sx={{ ml: '-5px', mr: 1, color: 'gray' }} /> }}
                                placeholder="Search"
                                hiddenLabel
                                fullWidth
                            />
                        </ListItemText>
                        <ListItemButton aria-label="sort-alphabetically" onClick={() => setSortBy(sortBy === 'asc' ? 'desc' : 'asc')}>
                            <Tooltip title="Sort Alphabetically">
                                <SortByAlpha />
                            </Tooltip>
                        </ListItemButton>
                    </ListItem>
                </Box>
                {filteredAndsortedFields.map((field) => (
                    <ListItem key={field.id} sx={{ py: 0 }}>
                        <ListItemAvatar style={{ width: '20%' }}>
                            <Checkbox checked={selectedFieldList.map((el) => el.id).includes(field.id)} onChange={onSelectField(field)} />
                        </ListItemAvatar>
                        <ListItemText style={{ width: '80%', textAlign: 'center' }}>{field.name}</ListItemText>
                    </ListItem>
                ))}
            </Paper>
        </Grid>
    );
};
